import { useQuery } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type CarrierResult = {
  carrier_name: string
  plan_count: number
}

export function getInsuranceCarriersQueryKey () {
  return ['insurance_carriers']
}

export function useGetInsuranceCarriers () {
  return useQuery<CarrierResult[], GrapeAPIErrorType>({
    queryKey: getInsuranceCarriersQueryKey(),
    queryFn: async () => {
      const response = await fetch(
        '/api/web/brokers/medical_plans/carriers' // eslint-disable-line thatch/no-bare-fetch
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
